import axios from "axios";
import authHeader from "@/services/auth-header";
import authHeaderMultiPart from "@/services/auth-header-multi-part";

const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api`;
const version = "v2";
const main = "Intranet";
const sub = "Common";

// ThisQuarterFundingModel
// {
//   "goalName": "string",
//   "currentGoalAmount": 0,
//   "nextGoalAmount": 0,
//   "currentQuarterTotal": 0,
//   "monthlyFundings": [
//     {
//       "year": 0,
//       "month": 0,
//       "fundingAmount": 0
//     }
//   ]
// }

class CommonService {
  getThisQuarterFunding(priorMonth) {
    return axios.get(
      `${API_URL}/${version}/${main}/${sub}/ThisQuarterFunding/${priorMonth}`,
      {
        headers: authHeader(),
      }
    );
  }
  
  postConvertBundlingBookmarks(formData) {
    return axios.post(
      `${API_URL}/${version}/${main}/${sub}/ConvertBundlingBookmarks`, formData, {
        responseType: "blob", 
        headers: authHeaderMultiPart() 
      }
    );
  }
}
 
export default new CommonService();
